export default "__VITE_PUBLIC_ASSET__c1c23212__"